import React, { useState, useEffect, useContext } from "react";
import { CircularProgress } from "@mui/material";
import AppContext from "../../../container/context";
import ijws from "../../../services/ijws";
import ActionTable from "../../../components/table/ActionTable";
import { mergeParams } from "../../../helpers/helpers";
import Form from "../../../components/form";

const Lista = ({ history, location }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [niveis, setNiveis] = useState([]);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );

  useEffect(() => {
    listarNiveis();
  }, []);

  const listarNiveis = (form = dados) => {
    setCarregando(true);
    setDados(form);

    ijws
      .get("admin/niveis/listar", form)
      .then((niveis) => {
        setNiveis(niveis);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar os níveis");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 4,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: listarNiveis,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Níveis",
    array: niveis,
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "ordem",
        label: "Ordem",
      },
    ],
    key: "id",
    newItemAction: () => history.push("/app/nivel/0"),
    onLineClick: (id) => history.push(`/app/nivel/${id}`),
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <CircularProgress color="info" />
        </div>
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
};

export default Lista;
